import api from './api';

export interface Vocabulary {
  id: string;
  user_id: string;
  word: string;
  translation: string;
  example_sentence?: string;
  category?: string;
  difficulty_level?: string;
  date_added: string;
  times_reviewed: number;
  mastery_level: number;
  created_at: string;
  updated_at?: string;
}

export interface VocabularyCreate {
  word: string;
  translation: string;
  example_sentence?: string;
  category?: string;
  difficulty_level?: string;
  date_added: string;
}

export interface VocabularyUpdate {
  word?: string;
  translation?: string;
  example_sentence?: string;
  category?: string;
  difficulty_level?: string;
  times_reviewed?: number;
  mastery_level?: number;
}

class VocabulariesService {
  async getAll(): Promise<Vocabulary[]> {
    const response = await api.get('/vocabularies/');
    return response.data;
  }

  async getById(id: string): Promise<Vocabulary> {
    const response = await api.get(`/vocabularies/${id}`);
    return response.data;
  }

  async create(vocabulary: VocabularyCreate): Promise<Vocabulary> {
    const response = await api.post('/vocabularies/', vocabulary);
    return response.data;
  }

  async update(id: string, vocabulary: VocabularyUpdate): Promise<Vocabulary> {
    const response = await api.patch(`/vocabularies/${id}`, vocabulary);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/vocabularies/${id}`);
  }
}

export const vocabulariesService = new VocabulariesService();

